<template>
  <div class="map-page">
    <v-container fluid>
      <use-call-centers-filials-list v-if="showCallCenterFilials"/>
      <orders-and-couriers-map v-else/>
    </v-container>
  </div>
</template>

<script>

  import { mapGetters, mapState } from 'vuex'

  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import OrdersAndCouriersMap from '@/components/geo/couriers-map/OrdersAndCouriersMap.vue'
  import UseCallCentersFilialsList from '@/components/callcenter/UseCallCentersFilialsList.vue'

  export default {
    name: 'CouriersMap',
    mixins: [mixinSnackbarMessage],
    components: {
      UseCallCentersFilialsList,
      OrdersAndCouriersMap,
    },
    data () {
      return {
        isLoading: true,
        filial: {},
      }
    },
    computed: {
      ...mapState({
        couriers: state => state.couriers.currentCouriers,
        ordersFilterDate: state => state.orders.ordersFilterDate,
        orders: state => state.orders.orders,
      }),
      ...mapGetters({
        globalFilial: 'branches/getGlobalFilial',
        globalFilialIsCallCenter: 'branches/getGlobalFilialIsCallCenter',
      }),
      showCallCenterFilials () {
        return !this.$route.query?.filialId && this.globalFilialIsCallCenter
      },
    },
    methods: {

    },

  }
</script>

<style scoped lang="less">

</style>
